import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Header from "@/layouts/Header/Header";
import Sidebar from "@/layouts/Sidebar/Sidebar";
import "./styles.css";
import Footer from "../Footer";
import FooterBottom from "../FooterBottom";
import { useSelector } from "react-redux";

export default function MainLayout() {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("sm"));
  // const role = useSelector((state) => state.auth.auth.role);
  const role = localStorage.getItem("role");  
  // Sidebar open state: open on large, closed on small
  const [open, setOpen] = useState(isLarge);

  // Sync with breakpoint changes
  useEffect(() => {
    setOpen(isLarge);
  }, [isLarge]);

  const toggleSidebar = () => setOpen(prev => !prev);
  const drawerMarginLeft = role === "vendor"
  ? { xs: 0, sm: open ? "240px" : 0, md: open ? "280px" : 0 }
  : { xs: 0, sm: open ? "0px" : 0, md: open ? "0px" : 0 };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header */}

      {/* Main area: sidebar + content */}
      <Header toggleSidebar={toggleSidebar} isSidebarOpen={open} />
      <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden",  marginTop: role === "vendor" 
      ? { xs: 8, sm: 10, md: 10, lg: 10 }
      : { xs: 8, sm: 10, md: 10, lg: 7 } }}>
         {/* Sidebar: Only show if role is vendor */}
         {role === "vendor" && (
          <Sidebar open={open} onClose={() => !isLarge && setOpen(false)} />
        )}
        <Box
          sx={{
            flexGrow: 2,
            overflowY: "auto",
            overflowX: "hidden",
            transition: "margin-left 0.3s ease",
            // shift content right by drawer width when open on sm+
            marginLeft: drawerMarginLeft,
            }}
          >
            <Outlet />
          </Box>
          </Box>

          {/* Footer sticks to bottom when content is short */}
      <FooterBottom />
    </Box>
  );
}
